<template>
  <div>
    <AppMenu :modulo="55" v-on:set-modulo="setModulo"></AppMenu>
    <div class="container-fluid mt-2 bg-light">
      <div class="row">
        <main role="main" class="col-sm-12 p-3">
          <h1 v-show="!actual" v-if="usuario" class="text-center text-dark mt-5">Bienvenido {{ usuario.nombre }}</h1>
          <component v-bind:is="actual"></component>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppMenu from './components/AppMenu.vue'
import ManteCartaKit from './components/ManteCartaKit.vue';
import ManteCartaMesa from './components/ManteCartaMesa.vue';
import ManteCartaEnlace from './components/ManteCartaEnlace.vue';
import ManteConfiguracion from './components/ManteConfiguracion.vue';
import ManteCartaProducto from './components/ManteCartaProducto.vue';
import ManteCartaCategoria from './components/ManteCartaCategoria.vue';
import ManteCartaRestaurante from './components/ManteCartaRestaurante.vue';
import ManteBazar from './components/ManteBazar.vue';
import ManteBazarUsuario from './components/ManteBazarUsuario.vue';
import BazarCompra from './components/BazarCompra.vue';
import BazarCompraDirecta from './components/BazarCompraDirecta.vue';
import BazarSaldo from './components/BazarSaldo.vue';
import BazarObligacion from './components/BazarObligacion.vue';

export default {
  name: 'App',
   data: () => ({
      actual: null,
      usuario: null
  }),
  created () {
    this.getUsuario();
  },
  methods: {
    setModulo(mdl) {
      this.actual = mdl;
    },
    getUsuario() {
      axios
      .get(this.UrlBase + '/catalogo/get_info_usuario')
      .then(res => {
        this.usuario = res.data;
      }).catch(e => {
        alert('Usuario ' + e);
      });
    }
  },
  components: {
    AppMenu,
    BazarCompra,
    BazarCompraDirecta,
    ManteCartaKit,
    ManteCartaMesa,
    ManteCartaEnlace,
    ManteConfiguracion,
    ManteCartaProducto,
    ManteCartaCategoria,
    ManteCartaRestaurante,
    ManteBazar,
    ManteBazarUsuario,
    BazarSaldo,
    BazarObligacion
  }
}
</script>